module.exports = __webpack_public_path__ + "static/media/shanghai-aerial-sunset.5352d6ae.jpg";